export default __webpack_public_path__ + "static/media/secureConnection.664ea35d.svg";